import axios, { AxiosError, AxiosResponse } from "axios";
import { NetworkError, UnexpectedError } from "./Errors";

export type AddressSearchItem = {
  id: string;
  address: string;
};

export type AddressSearchResult = AddressSearchItem[];

const URL = "/spirit/address-search/";

/**
 * Fetch the server for addresses with the given postcode.
 *
 * @param postcode - The postcode.
 * @returns A list of AddressSearchItem objects.
 * @throws {NetworkError}
 * @throws {UnexpectedError}
 */
export async function searchAddress(
  postcode: string
): Promise<AddressSearchResult> {
  let response: AxiosResponse<AddressSearchResult>;

  try {
    response = await axios.get(URL, { params: { postcode } });
  } catch (error) {
    console.error(error);

    if ((<AxiosError>error).response) {
      const err = <AxiosError>error;
      throw new NetworkError(
        "Error while reportig school not found.",
        err.response?.status
      );
    }
    throw new UnexpectedError(
      `Error while reportig school not found. ${error}`
    );
  }

  return response.data;
}
